export interface FormatAmountOptions {
  numberOfDecimals: number;
}

/**
 * Format an amount with its currency
 * @note it was a UX decision not to use the native Intl.NumberFormat:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
 *
 * @param number amount
 * @param string currencyCode
 * @param Partial<FormatAmountOptions> formatOptions
 *
 * @return string
 */
export const formatAmount = (
  amount: number,
  currencyCode: string,
  formatOptions: Partial<FormatAmountOptions> = {}
): string => {
  const { numberOfDecimals }: FormatAmountOptions = {
    numberOfDecimals: 0,
    ...formatOptions
  };

  return `${amount.toFixed(numberOfDecimals)} ${currencyCode}`.trim();
};
